import Sale from "../../../components/roulette/mobile/Sale";
import React from "react";
import RouletteProvider from "../../../store/roulette/RouletteProvider";

const RouletteMobile = ({appClass = ""}) => {
    return (
        <RouletteProvider>
            <Sale appClass={appClass}/>
        </RouletteProvider>
    )
}

export  default RouletteMobile